import { connect } from 'react-redux';
import { ApplicationState } from '~/Store';

import AddForm from './AddForm';

function mapStateToProps(state: ApplicationState): {
	canCreateGroup: boolean;
	isSaving: boolean;
} {
	return {
		canCreateGroup: Boolean(state.accessToken.accessToken),
		isSaving: state.groupProduct.updatingGroupIds.size > 0,
	};
}

export default connect(mapStateToProps)(AddForm);
